export default __webpack_public_path__ + "static/media/slider1.9e0978a6.jpeg";